
const RecivedDocuments = () => {
  return (
    <div>
      
    </div>
  )
}

export default RecivedDocuments
